var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebHacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#facdd5}.st1{fill:#e83c5a}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3 23.9v10.2c0 1.1-.5 1.9-1.5 2.4-2 1.1-4 2.3-6 3.5-3.1 1.8-6.2 3.6-9.2 5.4-.9.5-1.7 1-2.6 1.5-.8.4-1.6.4-2.4 0-1.9-1.1-3.8-2.2-5.8-3.3-1.4-.8-2.8-1.6-4.3-2.5-1.9-1.1-3.9-2.3-5.8-3.4l-2.1-1.2c-.8-.5-1.2-1.1-1.2-2V13.8c0-1.3.5-2.1 1.6-2.7 2.6-1.5 5.2-3 7.8-4.6 2.4-1.4 4.9-2.8 7.3-4.2.8-.4 1.5-.9 2.3-1.3 1-.5 1.9-.4 2.9.1 2.5 1.5 5 2.9 7.5 4.3 2.2 1.3 4.4 2.5 6.5 3.8 1.2.7 2.4 1.4 3.7 2.1.8.5 1.2 1.3 1.2 2.2.1 3.5.1 6.9.1 10.4zm-10.4-5.2v-1c0-.4-.1-.7-.6-.9-3.1-1.2-6.1-2.4-9.2-3.5-.1-.1-.4 0-.5 0-1 .4-1.9.7-2.9 1.1-2.1.8-4.3 1.7-6.4 2.5-.2.1-.4.3-.4.5 0 .9-.1 1.7 0 2.6.1 1.9.5 3.8 1.3 5.7 1.6 4 4.2 6.9 8.1 8.7.4.2.8.3 1.2.1 2.2-1 4.1-2.4 5.6-4.3 2.6-3.4 3.7-7.3 3.8-11.5z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9 18.7c-.1 4.2-1.2 8.1-3.9 11.4-1.5 1.9-3.4 3.3-5.6 4.3-.4.2-.8.1-1.2-.1-3.9-1.8-6.5-4.8-8.1-8.7-.7-1.8-1.1-3.7-1.3-5.7-.1-.8 0-1.7 0-2.6 0-.2.2-.4.4-.5 2.1-.9 4.3-1.7 6.4-2.5 1-.4 1.9-.8 2.9-1.1.2-.1.4-.1.5 0 3.1 1.2 6.1 2.4 9.2 3.5.5.2.6.5.6.9.1.5.1.8.1 1.1zm-2 .5c-.1-.3.2-.6-.3-.8-2.5-.9-4.9-1.9-7.4-2.8-.2-.1-.4-.1-.6 0-2.4.9-4.9 1.9-7.3 2.8-.3.1-.4.2-.4.5.2 1.5.3 3 .7 4.4 1 3.9 3.2 7 6.9 8.9.3.1.5.2.8 0 3.2-1.6 5.3-4.2 6.5-7.5.7-1.7 1-3.6 1.1-5.5z",
    className: "st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 19.2c-.1 1.9-.4 3.7-1.1 5.5-1.3 3.3-3.3 5.9-6.5 7.5-.3.1-.5.1-.8 0-3.7-1.9-5.9-5-6.9-8.9-.4-1.4-.5-3-.7-4.4 0-.3.1-.4.4-.5 2.4-.9 4.9-1.9 7.3-2.8.2-.1.4-.1.6 0 2.5.9 4.9 1.9 7.4 2.8.5.2.1.6.3.8zm-9-.6v6.7h2v-6.7h-2zm2 8h-2v2h2v-2z",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9 18.6h2v6.7h-2v-6.7zM24.9 26.6v2h-2v-2h2z",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebHacks);
export default __webpack_public_path__ + "static/media/web-hacks.3dda741c50cf597fe8c408d29c8fafca.svg";
export { ForwardRef as ReactComponent };